export default __webpack_public_path__ + "static/media/white-create-24px.c755228a.svg";